import request from '@/utils/request'

export interface VAStatus {
  hasAccess: boolean
  entitlements: any[]
  userId?: string
  expiryInfo?: {
    expiryDate: Date | string
    daysRemaining: number
    isExpiringSoon: boolean
  }
}

export interface VAEligibility {
  eligible: boolean
  reason?: string
  requiresV2Plus: boolean
  deviceType?: string
}

export interface VAStatistics {
  totalActiveUsers: number
  preOrderUsers: number
  regularUsers: number
  trialUsers: number
  expiringIn30Days: number
  expiringIn90Days: number
}

export interface ExpiringUser {
  userId: string
  entitlement: any
  daysRemaining: number
}

export const getVAStatus = (userId: string) =>
  request({
    url: `/users/${userId}/voice-assistant/status`,
    method: 'get'
  })

export const checkVAEligibility = (userId: string, deviceId?: number) =>
  request({
    url: `/users/${userId}/voice-assistant/eligibility`,
    method: 'get',
    params: { deviceId }
  })

export const grantVA = (userId: string, durationMonths: number, reason: string, adminId?: string, deviceSerialNumber?: string) =>
  request({
    url: `/users/${userId}/voice-assistant/grant`,
    method: 'post',
    data: { durationMonths, reason, adminId, deviceSerialNumber }
  })

export const extendVA = (userId: string, extensionMonths: number, reason: string, adminId?: string) =>
  request({
    url: `/users/${userId}/voice-assistant/extend`,
    method: 'post',
    data: { extensionMonths, reason, adminId }
  })

export const revokeVA = (userId: string, reason: string, adminId?: string) =>
  request({
    url: `/users/${userId}/voice-assistant`,
    method: 'delete',
    data: { reason, adminId }
  })

export const getVAStatistics = () =>
  request({
    url: '/voice-assistant/statistics',
    method: 'get'
  })

export const getExpiringUsers = (days?: number) =>
  request({
    url: '/voice-assistant/expiring',
    method: 'get',
    params: { days }
  })

export const checkTransitionPeriod = () =>
  request({
    url: '/voice-assistant/transition-period',
    method: 'get'
  })
